export default __webpack_public_path__ + "static/media/ferramenta-baixar-videos-img5.33056d9b.jpeg";